import * as types from './actionTypes'

const initialState = {
  menu: [],
  page: null,
  pageSlug: null,
  isLoadingPage: true,
  isRefreshPage: false,
  ribbonTarget: '',
  removeProcess: {
    isOpen: false,
    items: {},
    removeId: '',
  },
}

export default function home(state = initialState, action = {}) {
  switch (action.type) {
    case types.GET_MENU:
      return {
        ...state,
        menu: Array.isArray(action.menu) ? action.menu : [{}],
      }
    case types.GET_PAGE:
      return {
        ...state,
        page: action.page,
        isLoadingPage: false,
      }
    case types.GET_PAGE_REQUEST:
      return {
        ...state,
        isLoadingPage: true,
      }
    case types.REFRESH_PAGE:
      return {
        ...state,
        isRefreshPage: action.isRefreshPage,
      }
    case types.GET_FINAL:
      return {
        ...state,
        isLoadingPage: false,
      }
    case types.GET_RIBBON_TARGET:
      return {
        ...state,
        ribbonTarget: action.idRibbonTarget,
      }
    case types.UPDATE_STATUS_REMOVE_PROCESS:
      return {
        ...state,
        removeProcess: action.payload,
      }
    case types.UPDATE_SEARCH:
      return {
        ...state,
        page: {
          ...state.page,
          search: action.queryParams,
        },
      }
    case types.UPDATE_PAGE_SLUG:
      return {
        ...state,
        pageSlug: action.payload,
      }
    case types.UPDATE_REACTED_CONTENT:
      return {
        ...state,
        reactedContents: action.payload,
      }
    default:
      return state
  }
}
